/* PIPEFY AGENTIC — Guía de tallas Lola Mora */
(function () {
  if (window.__pipefyGT) return;
  window.__pipefyGT = true;

  function modalFor(id) {
    return document.getElementById('pipefy-gt-' + id) || document.querySelector('[data-pipefy-gt]');
  }
  function open(modal) {
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.classList.add('pipefy-gt-open');
    document.body.classList.add('pipefy-gt-open');
  }
  function close(modal) {
    if (!modal) return;
    modal.hidden = true;
    if (!document.querySelector('[data-pipefy-gt]:not([hidden])')) {
      document.documentElement.classList.remove('pipefy-gt-open');
      document.body.classList.remove('pipefy-gt-open');
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-pipefy-gt-open]');
    if (opener) {
      e.preventDefault();
      var scope = opener.closest('form, .t4s-product__info-wrapper, .t4s-product-info, body') || document;
      var modal = scope.querySelector('[data-pipefy-gt]') || modalFor(opener.getAttribute('data-pipefy-gt-open'));
      open(modal);
      return;
    }

    var closer = e.target.closest('[data-pipefy-gt-close]');
    if (closer) {
      e.preventDefault();
      close(closer.closest('[data-pipefy-gt]'));
      return;
    }

    var tab = e.target.closest('[data-pipefy-gt-tab]');
    if (tab) {
      e.preventDefault();
      var wrap = tab.closest('[data-pipefy-gt]');
      if (!wrap) return;
      var key = tab.getAttribute('data-pipefy-gt-tab');
      wrap.querySelectorAll('[data-pipefy-gt-tab]').forEach(function (t) {
        t.classList.toggle('is--active', t === tab);
      });
      wrap.querySelectorAll('[data-pipefy-gt-panel]').forEach(function (p) {
        p.classList.toggle('is--active', p.getAttribute('data-pipefy-gt-panel') === key);
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      document.querySelectorAll('[data-pipefy-gt]:not([hidden])').forEach(close);
    }
  });
})();
